jQuery(document).ready(function(){
    initTextAnimationDom();
    checkTextAnimationScroll();
    jQuery(window).scroll(checkTextAnimationScroll);
})

function initTextAnimationDom(){
    jQuery('.text-appear-animation').each(function(){
        let currentTextWrapper = jQuery(this);
        let wrapper = jQuery('<span/>').addClass('text-appear-animation-wrapper hidden');
        currentTextWrapper.wrap(wrapper);
    })
}

function checkTextAnimationScroll(){
    let scrollTop = jQuery(window).scrollTop();
    let wHeight = jQuery(window).outerHeight();
    jQuery('.text-appear-animation-wrapper').each(function(){
        let currentTextWrapper = jQuery(this);
        if((scrollTop+wHeight)>currentTextWrapper.offset().top+100) currentTextWrapper.removeClass('hidden');
    });
}